import { TranslateService } from "@ngx-translate/core";
import { Component, inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { slideDownUp, toggleAnimation } from "src/app/shared/animations";
import { DialogRef, DialogService } from "@ngneat/dialog";
import { QnAService } from "../service/qna.service";
import { QuestionAndAnswer } from "../model/qna.model";
import Swal from "sweetalert2";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { PopupType } from "src/app/shared/enums/popup-types";

@Component({
  selector: "app-qna-list",
  templateUrl: "./qna-list.component.html",
  animations: [slideDownUp, toggleAnimation],
  standalone: false,
})
export class QnAListComponent implements OnInit {
  language = "sr";
  isLoading = false;
  questions!: QuestionAndAnswer[];
  accordians: { [key: number]: boolean } = {};
  questionToEditId?: number;

  @ViewChild("addQuestionModalTemplate") addQuestionModalTemplate!: TemplateRef<unknown>;

  addQuestionModal!: DialogRef;
  private dialog = inject(DialogService);

  sortableOptions = {
    animation: 150,
    onUpdate: (event: any) => this.onOrderChange(event),
  };

  constructor(
    private translate: TranslateService,
    private qnaService: QnAService,
  ) {}

  ngOnInit(): void {
    this.loadQuestions();
  }

  loadQuestions() {
    this.isLoading = true;
    const getSubscription = this.qnaService.getQuestions().subscribe((response) => {
      getSubscription.unsubscribe();
      this.isLoading = false;
      this.questions = response;
    });
  }

  onOrderChange(event: any) {
    const oldIndex = event.oldIndex;
    const newIndex = event.newIndex;

    if (oldIndex !== newIndex) {
      const updatedPositions = this.questions.map((q, index) => ({
        ...q,
        position: index + 1,
      }));

      this.isLoading = true;
      const updateSubscription = this.qnaService.updateOrder(updatedPositions).subscribe(() => {
        updateSubscription.unsubscribe();
        this.isLoading = false;
      });
    }
  }

  openCreateModal(id: number | undefined = undefined) {
    this.questionToEditId = id;
    this.addQuestionModal = this.dialog.open(this.addQuestionModalTemplate, {
      id: `dialog-${crypto.randomUUID()}`,
    }); ;
  }

  closeCreateModal() {
    this.addQuestionModal.close();
    this.loadQuestions();
  }

  openDeleteModal(id: number) {
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("qna.confirm_delete"),
      showCancelButton: true,
      confirmButtonText: this.translate.instant("Yes"),
      cancelButtonText: this.translate.instant("No"),
      customClass: {
        confirmButton: "swal2-confirm btn btn-primary",
        cancelButton: "swal2-cancel btn btn-secondary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        const deleteSub = this.qnaService.deleteQuestion(id).subscribe({
          next: () => {
            deleteSub.unsubscribe();
            showMessage(PopupType.Success, this.translate.instant("qna.successfull_delete"));
            this.loadQuestions();
          },
          error: () => {
            deleteSub.unsubscribe();
            showMessage(PopupType.Danger, this.translate.instant("users_page.invalid_delete"));
          },
        });
      }
    });
  }

  toggleAccordion(index: number) {
    this.accordians[index] = !this.accordians[index];
  }
}
